// export function getCoreUrl(apiVersion: String) {
//   return `https://test0.wenxiaobai.com:8999/${apiVersion}`;
// }

import { getCustomApiBaseUrl } from '../../constant';

// export function getUserUrl(apiVersion: String) {
//   return `https://test0.wenxiaobai.com:51801/${apiVersion}`;
// }

// export function getBotUrl(apiVersion: String) {
//   return `https://test0.wenxiaobai.com:51901/${apiVersion}`;
// }

//  正式代码
export const apiVersion: string = 'api/v1.0';
export const purVersion: string = 'v1.0';

export const baseUrl: string = getCustomApiBaseUrl();
export const baseProtocol: string = 'https://';
export const basePort = '443';

export const iframeLink: string = 'https://web-h5-dev.wenxiaobai.com/end.html';
// process.env.API_PREFIX === 'prod'
//   ? 'https://activity.wenxiaobai.com/end.html'
//   : 'https://web-h5-dev.wenxiaobai.com/end.html';

export function getCoreUrl(apiVersion: string) {
  // return `https://test0.wenxiaobai.com:8999/api/v1.0/core`;
  return `${baseUrl}:${basePort}/${apiVersion}/core`;
}

export function getUserUrl(apiVersion: string) {
  return `${baseUrl}:${basePort}/${apiVersion}/user`;
}

export function getBotUrl(apiVersion: string) {
  return `${baseUrl}:${basePort}/${apiVersion}/bot`;
}

export function getFileUrl(apiVersion: string) {
  return `${baseUrl}:${basePort}/${apiVersion}/file`;
}

// payment 相关接口前缀 ｜ 金币查询 ｜ 签到 ｜ 金币购买等
export function getRestBaseUrl() {
  // return `${baseProtocol}${baseUrl}:${basePort}/${apiVersion}/rest/api`;
  return `${baseUrl}:${basePort}/rest/api`;
}

export const RESPONSE_CODE = {
  SUCCESS: 0, // "操作成功"),
  // 登录段1~50
  NEED_LOGIN: 5000, // "需要登录后操作"),
  LOGIN_PASSWORD_ERROR: 5001, // "密码错误"),
  CHECK_CODE_INVALID: 5002, // "验证码失效"),
  CHECK_CODE_ERROR: 5003, // "验证码错误"),
  LOGIN_IS_BANNED: 5004, //  "账号已被封禁"),
  USERID_MISMATCH: 5005, //  "非法请求"),
  // TOKEN50~100
  TOKEN_INVALID: 5006, //  "无效的TOKEN"),
  TOKEN_EXPIRE: 5007, // "TOKEN已过期"),
  TOKEN_REQUIRE: 5008, //  "TOKEN是必须的"),
  VISITORID_REQUIRE: 5009, //  "VISITORID是必须的"),
  VISITORID_EXPIRE: 5010, // "VISITORID已过期"),
  VISITORID_INVALID: 5011, //  "无效的VISITORID"),
  VISITORID_MISMATCH: 5012, // "非法请求"),
  // SIGN验签 100~120
  SIGN_INVALID: 5013, // "无效的SIGN"),
  SIG_TIMEOUT: 5014, //  "SIGN已过期"),
  //注册段
  REGISTER_PASS: 5015, //  "用户已注册"),
  REGISTER_PATIENT: 5016, // "请耐心等待审核"),
  //限流段
  TOURIST_LIMIT: 5106, // "为保障对话记录与服务体验，请登录后继续使用"),
  // 参数错误 500~1000
  PARAM_REQUIRE: 6000, //  "缺少参数"),
  PARAM_INVALID: 6001, //  "无效参数"),
  PARAM_IMAGE_FORMAT_ERROR: 6002, // "图片格式有误"),
  SERVER_ERROR: 500, //  "服务器内部错误"),
  // 数据错误 1000~2000
  DATA_EXIST: 7000, // "数据已经存在"),
  USER_DATA_NOT_EXIST: 7001, //  "User数据不存在"),
  DATA_NOT_EXIST: 7002, // "数据不存在"),
  // 数据错误 3000~3500
  NO_OPERATOR_AUTH: 4000, // "无权限操作"),
  NEED_ADMIND: 4001, //  "需要管理员权限"),
  //更换手机号
  UPDATEPHONE_ERROR: 5019, //  "该手机号码已被绑定");
};

export const DEFAULT_RECOMMEND = [
  {
    textContent: '😡 同事怼我怎么办',
    textId: '1000001',
  },
  {
    textContent: '💥 小白，帮我怼人！！',
    textId: '1000002',
  },
  {
    textContent: '☁️ 今天心情不好',
    textId: '1000003',
  },
  {
    textContent: '🏋️‍♂️ 生活压力好大呀',
    textId: '1000004',
  },
  {
    textContent: '💔 失恋了好难受',
    textId: '1000005',
  },
  {
    textContent: '📈 股票涨了，赚了好多钱',
    textId: '2000001',
  },
  {
    textContent: '🤑今天打牌赢了',
    textId: '2000002',
  },
  {
    textContent: '🎉 耶，工作很顺利，早早完成了',
    textId: '2000003',
  },
  {
    textContent: '🚨 热门速递: 今日必知大事',
    textId: '3000001',
  },
  {
    textContent: '📱 宝宝总是玩手机怎么办',
    textId: '5000001',
  },
  {
    textContent: '🏖️ 度假不知道带宝宝去哪里玩',
    textId: '5000002',
  },
  {
    textContent: '🤰 孕期怎么变美丽呢',
    textId: '5000003',
  },
];

export const TRACK_PAGE = {
  CHAT: {
    key: 'chat',
    area: {
      CONVERSATION: {
        key: 'conversation',
        element: {
          QUESTION: 'question',
          ANSWER: 'answer',
          RELATED_QUESTION: 'related_question',
          PRAISE_BTN: 'praise_btn',
          DISLIKE_BTN: 'dislike_btn',
          PRE_BTN: 'pre_btn',
          NEXT_BTN: 'next_btn',
          REFRESH_BTN: 'refresh_btn',
          PPT_CREATE: 'ppt_create',
        },
      },
      INPUT: {
        key: 'input',
        element: {
          INPUT: 'input',
          SEND_BTN: 'send_btn',
          NEW_START_BTN: 'new_start_btn',
          PAUSE: 'pause',
        },
      },
      CHAT: {
        key: 'chat',
        element: {
          RECOMMEND: 'recommend',
        },
      },
    },
  },
  HISTORY: {
    key: 'history',
  },
  FEED: {
    key: 'feed',
  },
  FEED_DETAIL: {
    key: 'feed_detail',
  },
  SHARE_CHAT: {
    key: 'share_chat',
  },
  SHARE_DEEP_RESEARCH: {
    key: 'share_deep_research',
    area: {
      SHARE_BTN: 'share_btn',
      HOME_BTN: 'home_btn',
    },
  },
  SHRE_CARD: {
    key: 'share_card',
  },
  LOGIN: {
    key: 'login',
  },
  SETTING: {
    key: 'setting',
  },
  DISCOVERY: {
    key: 'discovery',
  },
};

export const SSE_CONSTS = {
  INPUT_WAY: {
    PROACTIVE: 'proactive', //  主动发送
    RELATIVED: 'related', //  追问
    ICEBREAKING: 'icebreaking', //  破冰
    RECOMMEND: 'recommend',
    AUTOMATIC: 'automatic', // 小白研报免费生成
  },
};

export const EMPTY_MESSAGE = '抱歉，网络开小差了，请再问我一次。';

export enum EUploadType {
  FILE = 'file',
  IMAGE = 'image',
}
export interface IUploadConfig {
  key: EUploadType;
  title: string;
  lengthLimit: number; // 限制的上传数量
  exceedLengthMsg: string; // 超出限制数量提示文案
  exceedTotalLengthMsg: string; // 超出上传总数量提示文案
  sizeLimit: number; // 限制的上传大小
  exceedSizeMsg: string; // 超出上传大小提示文案
  acceptType: string[]; // 限制的上传格式
  exceedAcceptTypeMsg: string; // 超出限制上传格式提示文案
  isForbidden: (params: { files: File[] }) => boolean; // 上传是否被禁止上传
  forbiddenMsg: string; // 禁止上传后提示文案
  forbiddenUploadMsg: string; // 禁止不同类型的文件上传提示文案
  dropUploadTips: string; // 拖拽上传用户提示文案
  buttonUploadTips: string; // 按钮上传用户提示文案
}
export type TUploadConfigMap = Record<EUploadType, IUploadConfig>;

const imageLengthLimit = 1; // 图片限制上传1个
const imageSizeLimit = 10; // 图片限制上传大小10MB
const fileLengthLimit = 10; // 文件限制上传10个
const fileSizeLimit = 100; // 文件限制上传大小100MB

export const FILES_LENGTH_LIMIT = fileLengthLimit;
export const ACCEPT_IMAGE_TYPE = [
  'image/jpg',
  'image/png',
  'image/jpeg',
  'image/gif',
  'image/bmp',
  'image/webp',
];
export const ACCEPT_FILE_TYPE = [
  '.txt',
  'text/plain',
  '.pdf',
  'application/pdf',
  '.doc',
  'application/msword',
  '.docx',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  '.md',
  '.csv',
  'text/csv',

  '.xls',
  'application/vnd.ms-excel',
  '.xlsx',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  '.pptx',
  '.ppt',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  '.epub',
  '.mobi',
  '.azw3',
  '.fb2',
  '.rtf',
  '.lrf',
  '.lit',
  '.djvu',
  'application/vnd.ms-powerpoint',
  'application/epub+zip',
  'text/rtf',
  'application/mobi',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/wps-office.docx',
  'application/wps-office.doc',
  'application/wps-office.xls',
  'application/wps-office.xlsx',
  'application/wps-office.ppt',
  'application/wps-office.pptx',
  'application/wps-office.pdf',
  'application/wps-office.txt',
  'application/wps-office.csv',
];
export const EXCEED_ACCEPT_TYPE_MSG = '暂不支持此格式，请更换。';
export const UPLOAD_CONFIG_MAP: TUploadConfigMap = {
  [EUploadType.FILE]: {
    key: EUploadType.FILE,
    title: '文件',
    lengthLimit: fileLengthLimit,
    exceedLengthMsg: `最多可上传 ${fileLengthLimit} 个文件`,
    exceedTotalLengthMsg: `上传文件数目超出最大限制（${fileLengthLimit}个），超出部分无法上传。`,
    sizeLimit: fileSizeLimit * 1024 * 1024,
    exceedSizeMsg: `单个文件大小超过限制（${fileSizeLimit} MB），请调整后重试`,
    acceptType: ACCEPT_FILE_TYPE,
    exceedAcceptTypeMsg: EXCEED_ACCEPT_TYPE_MSG,
    isForbidden({ files }) {
      const uploadedImagesNum = files.filter(file =>
        ACCEPT_IMAGE_TYPE.includes(file.type)
      ).length;
      return uploadedImagesNum >= 1;
    },
    forbiddenMsg: '已经上传了图片，文件和图片不支持同时上传',
    forbiddenUploadMsg: '已经上传了文件，文件和图片不支持同时上传',
    dropUploadTips: `可上传${fileLengthLimit}个文件，每个最多${fileSizeLimit}MB，支持各类文档`,
    buttonUploadTips: `可上传${fileLengthLimit}个文件，每个最多${fileSizeLimit}MB，支持各类文档`,
  },
  [EUploadType.IMAGE]: {
    key: EUploadType.IMAGE,
    title: '图片',
    lengthLimit: imageLengthLimit,
    exceedLengthMsg: `仅支持上传 ${imageLengthLimit} 张图片`,
    exceedTotalLengthMsg: `上传文件数目超出最大限制（${fileLengthLimit}个），超出部分无法上传。`,
    sizeLimit: imageSizeLimit * 1024 * 1024,
    exceedSizeMsg: '单个图片大小超过限制（10 MB），请调整后重试',
    acceptType: ACCEPT_IMAGE_TYPE,
    exceedAcceptTypeMsg: EXCEED_ACCEPT_TYPE_MSG,
    isForbidden({ files }) {
      const uploadedFilesNum = files.filter(file =>
        ACCEPT_FILE_TYPE.includes(file.type)
      ).length;
      return uploadedFilesNum >= 1;
    },
    forbiddenMsg: '已经上传了文件，文件和图片不支持同时上传',
    forbiddenUploadMsg: '已经上传了图片，文件和图片不支持同时上传',
    dropUploadTips: `可上传${imageLengthLimit}个图片，单个文件最多${imageSizeLimit}MB`,
    buttonUploadTips: `可上传${imageLengthLimit}个图片，单个文件最多${imageSizeLimit}MB`,
  },
};
export const findUploadConfig = (file: File) => {
  const type = ACCEPT_IMAGE_TYPE.includes(file.type)
    ? EUploadType.IMAGE
    : EUploadType.FILE;
  return UPLOAD_CONFIG_MAP[type];
};

export const cookieKeys = {
  touristFst: '_qdd_tstp',
};

export const OLD_LOGIN_PAGE_URL = '/chat/tourist';
export const LOGIN_PAGE_URL = '/';
export const HOME_PAGE_URL = '/';
export function getBotChatPageUrl(botId: string | number) {
  return `/chat/${botId}`;
}

//  ys-chat 网信办 不过风控域名
//  ys-chat-normal 网信办 过风控域名
export const FOR_WXB_SPC_DOM = {
  'ys-chat.wenxiaobai.com': 78,
  'ys-chat-normal.wenxiaobai.com': 75,
};

export const CanPasteImage = ['cameraSolve'];

export const DEEP_RESEARCH_CAPABILITY = {
  key: 'deep_research',
  capability: 'otherBot',
  capabilityRang: 2,
  botId: 210041,
  icon: 'https://wy-static.wenxiaobai.com/bot-capability/prod/gray/xiaobaresearch.png',
  title: '小白研报',
};

export const CONVER_INPUT_ICON_SIZE = 18;

export const LOGIN_COOKIE_KEY = 'login';
export const VISITOR_ID_COOKIE_KEY = 'visitorId';
export const LOGIN_TOKEN_COOKIE_KEY = 'login_token';
export const USER_ID = 'user_id';
